import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Alert } from 'roo-ui/components';

const StyledAlert = styled(Alert)`
  width: 100%;
  top: 0px;

  min-height: 48px;
  margin: 0;
  font-size: 16px;
  font-weight: bold;

  > div > div {
    justify-content: center;
    > div {
      padding-right: 8px;
    }
  }
`;

const GlobalMessage = ({ show, type, message }) =>
  show &&
  type &&
  message && (
    <StyledAlert variant={type} data-testid="global-message" aria-live="assertive">
      {message}
    </StyledAlert>
  );

GlobalMessage.defaultProps = {
  type: 'info',
  message: '',
  show: false,
};

GlobalMessage.propTypes = {
  type: PropTypes.oneOf(['', 'success', 'info', 'error']),
  message: PropTypes.string,
  show: PropTypes.bool,
};

export default GlobalMessage;
